(function ($) {
    function rotateBanner() {
        var bannerContainer = $('.banner');
        var banners = bannerContainer.find('.bg-image');
        var activeBanner = bannerContainer.find('.bg-image.active');

        var nextBanner = activeBanner.next();
        if (nextBanner.length && nextBanner.hasClass('bg-image')) {
            activeBanner.fadeOut();
            nextBanner.fadeIn();
            banners.removeClass('active');
            nextBanner.addClass('active');
        } else {
            activeBanner.fadeOut();
            banners.first().fadeIn();
            banners.removeClass('active');
            banners.first().addClass('active');
        }
        setTimeout(rotateBanner, 4000);
    }

    $(document).ready(function () {
        var bannerContainer = $('.banner');
        if (bannerContainer.length) {
            if (bannerContainer.find('.bg-image').length > 1) {
                setTimeout(rotateBanner, 4000);
            }
        }
    });
})(jQuery);